// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quantity-picker[data-v-73b47c11] {\n  position: relative;\n  height: 38px;\n}\n", ""]);
// Exports
module.exports = exports;
